"use client";

import type {
    DraggableAttributes,
    DraggableSyntheticListeners,
} from "@dnd-kit/core";
import { GripVertical } from "lucide-react";

import { t } from "@/lib/localization";

/** The one grip every block drags by: the top-level rail and the nested
 *  toolbar. A drag never starts anywhere else, so text stays selectable. */
export default function BlockDragHandle({
    attributes,
    listeners,
}: {
    attributes: DraggableAttributes;
    listeners: DraggableSyntheticListeners;
}) {
    return (
        <button
            type="button"
            {...attributes}
            {...listeners}
            aria-label={t("lomda-v3-editor.block.drag")}
            className="flex size-6 cursor-grab items-center justify-center rounded text-muted-foreground transition hover:bg-muted active:cursor-grabbing"
        >
            <GripVertical className="size-3.5" />
        </button>
    );
}
